import Countdown from "react-countdown";

import React from "react";

const CountdownComponent = () => {
  const renderer = ({ minutes, seconds }) => {
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    return (
      <h1 className="text-lg font-semibold text-center text-red-500 py-2">
        {minutes}
        <span>:</span>
        {seconds}
      </h1>
    );
  };
  return (
    <div>
      <Countdown date={Date.now() + 3600000} renderer={renderer} />
    </div>
  );
};

export default CountdownComponent;
